const divFromEquipService = {
  noServices: 'Sem serviço adicionado',
  noFound: 'Nenhum serviço encontrado',
  onDemand: 'Serviço por demanda',
  remaining: (date, days) => days === 1 ? `Vencimento: ${date} (${days} dia restante)` : `Vencimento: ${date} (${days} dias restante)`,
  inDelay: (date, days) => days === 1 ? `Vencimento: ${date} (${days} dia em atraso)` : `Vencimento: ${date} (${days} dias em atraso)`,
  lastDay: 'O serviço irá expirar em breve, último dia de validade',
  mandatory: 'Obrigatório',
  haveOpenedActions: (actions) => actions === 1 ? `(O serviço tem ${actions} ação aberta ou vencida)` : `(O serviço tem ${actions} ações abertas ou vencidas)`,
  scheduledTo: 'Agendado para:',
  scheduledDate: 'Data agendada:',
  inactive: 'DESABILITADO',
  loadMore: 'Mostrar mais',
};

export default divFromEquipService;
